import { hidePageLoad, showPageLoad } from '../../../modules/actions'
import { customAxios as axios, getToken } from '../../../request'
import { addCourierUrl, addSubscriptionActivityUrl, updateInvoiceStatusUrl, sendInvoiceReminderUrl, mailInvoiceUrl, mailReceiptUrl } from '../api'
import { notification } from 'antd'
import { allGeneralSubscriptionUrl, getSingleGeneralSubscriptionByIdUrl } from '../api'
import { getArticleByIdUrl } from '../../article/apis'
// Added new Import
import { updateGeneralDetailsApi, addJournalToSubscriptionApi } from '../api/subscriptionEdits'

export const addSubscriptionActivityFxn = (valData) => async (dispatch) => {
  dispatch(showPageLoad())
  let { data } = await axios.post(addSubscriptionActivityUrl(), valData, getToken())
  dispatch(hidePageLoad())
  if (data.error) {
    notification.error({
      message: data.message || 'Error'
    })
  }
  return data
}
export const updateInvoiceStatusFxn = (valData) => async (dispatch) => {
  dispatch(showPageLoad())
  let { data } = await axios.post(updateInvoiceStatusUrl(), valData, getToken())
  dispatch(hidePageLoad())
  if (data.error) {
    notification.error({
      message: data.message || 'Error'
    })
  }
  return data
}
export const allGeneralSubscriptionFxn = (obj) => async (dispatch) => {

  let config = {
    params: obj,
    ...getToken()
  }
  let { data } = await axios.get(allGeneralSubscriptionUrl(), config)
  if (data.error) {
    notification.error({
      message: data.message || 'Error'
    })
  }
  return data
}

export const getSingleGeneralSubscriptionByIdFxn = (subscriptionId, selected = {}) => async dispatch => {
  dispatch(showPageLoad())
  try {
    let { data } = await axios.post(getSingleGeneralSubscriptionByIdUrl(), { subscriptionId }, getToken())
    dispatch(hidePageLoad())
    return data
  } catch (err) {
    dispatch(hidePageLoad())
    notification.error({
      message: err.response && err.response.status === 401
        ? 'Session expired. Please login again.'
        : 'Failed to load subscription data'
    })
    return { error: true, data: {} }
  }
}
export const addCourierFxn = (valData) => async (dispatch) => {
  dispatch(showPageLoad())
  let { data } = await axios.post(addCourierUrl(), valData, getToken())
  dispatch(hidePageLoad())
  if (data.error) {
    notification.error({
      message: data.message || 'Error'
    })
  }

  return data
}

// Added new function
export const updateGeneralSubscriptionFxn = (id, data) => {
  return dispatch => {
    return new Promise(async (resolve, reject) => {

      let { error, result } = await updateGeneralDetailsApi(id, data)

      if (!error) {
        resolve({ error: false, data: result })
      } else {
        resolve({ error: true })
      }
    })
  }
}

export const addJournalToSubscriptionFxn = (id, data) => {
  return dispatch => {
    return new Promise(async (resolve, reject) => {
      let { error, result } = await addJournalToSubscriptionApi(id, data)
      if (!error) {
        resolve({ error: false, data: result })
      } else {
        resolve({ error: true })
      }
    })
  }
}

export const sendInvoiceReminderFxn = (valData) => async (dispatch) => {
  dispatch(showPageLoad())
  let { data } = await axios.post(sendInvoiceReminderUrl(), valData, getToken())
  dispatch(hidePageLoad())
  if (data.error) {
    notification.error({
      message: data.message || 'Error'
    })
  } else {
    notification.success({
      message: 'Email send Successfully'
    })
  }
  return data
}

export const mailInvoiceFxn = (invoiceId) => async (dispatch) => {
  dispatch(showPageLoad())
  let { data } = await axios.get(mailInvoiceUrl(invoiceId), getToken())
  dispatch(hidePageLoad())
  if (data.error) {
    notification.error({ message: data.message || 'Failed to send invoice email' })
  } else {
    notification.success({ message: data.message || 'Invoice email sent successfully' })
  }
  return data
}

export const mailReceiptFxn = (paymentId) => async (dispatch) => {
  dispatch(showPageLoad())
  let { data } = await axios.get(mailReceiptUrl(paymentId), getToken())
  dispatch(hidePageLoad())
  if (data.error) {
    notification.error({ message: data.message || 'Failed to send receipt email' })
  } else {
    notification.success({ message: data.message || 'Receipt email sent successfully' })
  }
  return data
}
